import * as _ from 'lodash';
import { BASE_MODULES } from './app.modules';
import { BASE_MODULES_MOBILE } from './app.modules-mobile';

const confMapMobile: any = _.keyBy(BASE_MODULES_MOBILE, 'name');
const confMapDesktop: any = _.keyBy(BASE_MODULES, 'name');

export function arrayReplaceCustomizer(
  objValue: any,
  srcValue: any
): any[] | undefined {
  if (_.isArray(srcValue)) {
    return srcValue;
  }
  return undefined;
}

export function mergeConfigs(
  additionalModules: any,
  confMap: any = confMapDesktop
) {
  const resultMap: { [key: string]: any } = { ...confMap };

  const _additionalModules = _.keyBy(additionalModules, 'name');

  Object.keys(_additionalModules).forEach((name) => {
    const overrideObj = _additionalModules[name];
    const baseObj = resultMap[name];

    if (baseObj) {
      resultMap[name] = _.mergeWith(
        {},
        baseObj,
        overrideObj,
        arrayReplaceCustomizer
      );
    } else {
      resultMap[name] = overrideObj;
    }
  });

  const finalMergedConfig = _.values(resultMap);

  finalMergedConfig.forEach((module: any) => {
    if (module.widgets && typeof module.widgets === 'object') {
      const widgets = module.widgets;
      const hasAdmin = Object.prototype.hasOwnProperty.call(
        widgets,
        'org:admin'
      );
      const hasSupervisor = Object.prototype.hasOwnProperty.call(
        widgets,
        'org:supervisor'
      );

      if (hasAdmin && !hasSupervisor) {
        widgets['org:supervisor'] = widgets['org:admin'];
      } else if (hasSupervisor && !hasAdmin) {
        widgets['org:admin'] = widgets['org:supervisor'];
      }
    }
  });

  return _.values(finalMergedConfig);
}

const mergeConfigMobile = (additionalModules: any) =>
  mergeConfigs(additionalModules, confMapMobile);
const mergeConfigDesktop = (additionalModules: any) =>
  mergeConfigs(additionalModules, confMapDesktop);

export {
  BASE_MODULES,
  BASE_MODULES_MOBILE,
  mergeConfigDesktop,
  mergeConfigMobile,
};
